<h3 class="text-primary mb-12 text-4xl font-bold">
  {{ isArabic() ? companyDetails().titleAr : companyDetails().titleEn }}
</h3>

<div class="flex flex-col gap-11 rounded-xl bg-white px-6 py-12">
  <div class="flex items-start gap-4">
    <div class="h-[20rem] w-1/3 flex-1/3">
      <img [src]="imagePreviewUrl()" alt="company" class="h-full w-full object-contain p-4" />
    </div>
    <div class="h-[20rem] flex-2/3 rounded-xl p-8">
      <h3 class="border-border-card border-b py-3 text-3xl font-bold">
        {{ isArabic() ? companyDetails().titleAr : companyDetails().titleEn }}
      </h3>
      <div class="flex flex-col gap-4 py-4">
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold">{{ isArabic() ? "رمز الشركة / ID:" : "Company Code / ID:" }}</p>
          <p>{{ isArabic() ? companyDetails().descriptionAr : companyDetails().descriptionEn || "no description" }}</p>
        </div>
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold">{{ isArabic() ? "العنوان:" : "Address:" }}</p>
          <p>{{ isArabic() ? "لا توجد بيانات" : "No data" }}</p>
        </div>
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold">{{ isArabic() ? "رقم الموبايل:" : "Mobile Number:" }}</p>
          <p>{{ isArabic() ? "لا توجد بيانات" : "No data" }}</p>
        </div>
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold">{{ isArabic() ? "تاريخ الإنشاء" : "Created On:" }}</p>
          <p>{{ companyDetails().createdOn | dateTime }}</p>
        </div>
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold">{{ isArabic() ? "آخر تحديث" : "Last Updated:" }}</p>
          <p>{{ (companyDetails().lastModifiedOn | dateTime) || "no updates" }}</p>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h3 class="py-3 text-3xl font-bold">{{ isArabic() ? "الأصناف المرتبطة" : "Linked Products" }}</h3>
    <div>{{ isArabic() ? "لا توجد بيانات" : "No data" }}</div>
  </div>
</div>
